import React from 'react';
import SelectItemsCV from './controladorVista/selectTablaItemsCV';
import { ISelectItemsProps } from './interfaces';

const SelectItems: React.FunctionComponent<ISelectItemsProps> = (props) => <SelectItemsCV {...props} />;

export default SelectItems;
